import './styles.scss';
import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import tenantModule from '@audacious/tenant-admin-module';
import reportModule from '@audacious/ainq-admin-report-module';
import pulseModule from '@audacious/pulse-admin-module';
import promptModule from '@audacious/prompt-admin-module';
import AdminPortal from './portal';
import configurations from './configuration';

const modules = [
    tenantModule(configurations.tenant),
    reportModule(configurations.report),
    pulseModule(configurations.pulse),
    promptModule(configurations.prompt),
];

const adminPortal = new AdminPortal(modules);

const context = adminPortal.createContext(configurations.application);

const Component = adminPortal.getComponent();

const t = context.getComponentContext();

ReactDOM.render(
    <AppContainer>
        <Component context={t} />
    </AppContainer>,
    document.getElementById('application'),
);
